import { render, staticRenderFns } from "./PrevisionCreate.vue?vue&type=template&id=0b95364e&lang=pug&"
import script from "./PrevisionCreate.vue?vue&type=script&lang=js&"
export * from "./PrevisionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrevisionCreate.vue"
export default component.exports